module.exports = __webpack_public_path__ + "public/SiteIcons/payment-icons.png?d96ec2f9";